import { ExternalLinkIcon, SettingsIcon } from "lucide-react";

import {
  GithubConnectionStatus,
  GithubInstallationStatus,
  useGithubConnectionQuery,
  useGithubInstallationQuery,
} from "@/apollo/types";
import { Button } from "@/components/elements/Button";
import { LinkWithSlug } from "@/router";

export function GitHubContent() {
  const { data, loading: isLoadingConnection } = useGithubConnectionQuery({
    fetchPolicy: "cache-and-network",
  });
  const connection = data?.githubConnection;

  const { data: installationData, loading: isLoadingInstallation } =
    useGithubInstallationQuery();

  const appInstalled =
    installationData?.githubInstallation?.status ===
    GithubInstallationStatus.Active;

  const loading = isLoadingConnection || isLoadingInstallation;
  if (loading && (!connection || !installationData)) {
    return (
      <div className="text-sm text-muted-foreground">
        Loading connection details...
      </div>
    );
  }

  if (!appInstalled || connection?.status !== GithubConnectionStatus.Active) {
    return (
      <div>
        <Button
          as={LinkWithSlug}
          to="/settings/github"
          variant="outline"
          colorScheme="secondary"
          size="sm"
          icon={<SettingsIcon className="size-3.5" />}
        >
          Configure GitHub integration
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-between rounded-sm border px-4 py-3">
      <span className="text-sm text-muted-foreground">
        Connected to{" "}
        <span className="font-medium text-foreground">
          {connection.repoOwner}/{connection.repoName}
        </span>
      </span>
      <Button
        as={LinkWithSlug}
        to="/settings/github"
        variant="outline"
        colorScheme="secondary"
        size="xs"
        icon={<ExternalLinkIcon className="size-3.5" />}
      >
        Manage
      </Button>
    </div>
  );
}
